import React from 'react';
import { loadImg } from './utils';
import { AudioMedia } from 'components/basic';

// Renders an audio file using the existing AudioMedia component.
// AudioMedia itself is left untouched here — only wired up to the new file/type helpers.
function AudioPreview({ file, fileId, onlyPreview, innerRef, onAudioClick }) {
  return (
    <AudioMedia
      onlyPreview={onlyPreview}
      media={{
        ...file,
        uri: file instanceof File ? file : loadImg(file)
      }}
      itemId={file.counter || fileId}
      ref={innerRef}
      onAudioClick={onAudioClick}
      classContainer={!onlyPreview ? 'mc-flex mc-flex-center' : 'mc-ml5'}
    />
  );
}

export default AudioPreview;
